import React from 'react';

const ApiOutboxConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/template-messages/api-outbox',
			component: React.lazy(() => import('./ApiOutbox'))
		}
	]
};

export default ApiOutboxConfig;
